<template>
    
    <spinner v-if="!loaded" class="mb-3" ></spinner>

    <div class="analyze-page" v-else-if="loaded" > 
           
        <div class="row no-gutters mb-3 mt-3" v-if="contentType == 'full'" >
            
            <div class="col-12 col-md-6" >
                <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" @change="refresh_chart" clear-button-icon="false" :shortcuts="shortcuts" ></date-picker>
                
            </div>
            
            <div class="col-12 col-md-3 text-md-right mt-2 mt-md-0" style="line-height: 34px;"  >
                                
            </div>
            
            <div class="col-12 col-md-3 text-md-right" style=""  >
                
                Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                
            </div>
            
        </div>
        
        <div class="row no-gutters mb-3 mt-4" v-if="contentType == 'full'" >
            
            <div class="col-55 position-relative" >
                <b-form-input v-model="data_A.link" placeholder="Enter a link to check" class="search-input w-100" @change="refreshData('data_A')" />
                
                <font-awesome-icon v-if="data_A.link != default_links.link_A" :icon="['far', 'star']" @click="saveLink( 'A' )" class="reset-filter" v-bind:class="{ 'd-none' : !data_A.link }" style="margin-top: -25px; margin-right: 10px;" ></font-awesome-icon>
                <font-awesome-icon v-else-if="data_A.link == default_links.link_A" :icon="['fas', 'star']" class="reset-filter" v-bind:class="{ 'd-none' : !data_A.link }" style="margin-top: -25px; margin-right: 10px;" ></font-awesome-icon>
                
            </div>
            <div class="col text-center bg-color-graylight" > vs </div>
            <div class="col-55 position-relative" >
                <b-form-input v-model="data_B.link" placeholder="Enter compare link" class="search-input w-100" @change="refreshData('data_B')" />
                <font-awesome-icon icon="times-circle" @click=" data_B.link = ''" class="reset-filter" v-bind:class="{ 'd-none' : !data_B.link }" style="margin-top: -25px; margin-right: 10px;" >Clear</font-awesome-icon>
            </div>
            <div class="col text-center d-none" @click="refresh_chart" > <font-awesome-icon icon="arrow-circle-right" /> </div>
            
        </div>
        
        <div class="row no-gutters mb-4" v-if="contentType == 'full'" >
            
            <div class="col-12 mt-2" >
                <spinner v-if="!chartLoaded" ></spinner>
                
                <div v-else-if="chartLoaded && CHART_SERIES.length == 0" class="p-5 text-center" > No data to show </div>
                
                <div class="w-100 " v-else-if="chartLoaded && CHART_SERIES.length > 0" >

                    <!-- -->
                    <div class="row no-gutters pr-0 ml-0 border-bottom-gray border-top-gray " >

                        <div class="col-55 position-relative" >
                            
                            <div class="row" >
                                <div class="col p-3 border-right-gray text-right" >
                                    <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                        <h1 class="h2" v-if="data_A.unique == null" > - </h1>
                                        <h1 class="h2 cursor-pointer" v-else-if="data_A.unique != null" @click="get_list( 'all', data_A.link )" > 
                                            {{ Numberformatter( data_A.unique, 'plain-number' ) }}
                                        </h1>
                                        <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium cursor-pointer" @click="get_list( 'all', data_A.link )" > Visitors </p>
                                    </div>
                                </div>

                                <div class="col p-3 text-right border-right-gray " >
                                    <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                        <h1 class="h2" v-if="data_A.total == null" > - </h1>
                                        <h1 class="h2" v-else-if="data_A.total != null"  > 
                                            {{ Numberformatter( data_A.total, 'plain-number' ) }}
                                        </h1>
                                        <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium"  > Visits </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col text-center" >
    
                            
                            
                        </div>
                        <div class="col-55 position-relative" >
                            
                            <div class="row" >
                                <div class="col p-3 border-left-gray border-right-gray text-right"  >
                                    <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                        <h1 class="h2" v-if="data_B.unique == null || data_B.total == 0" > - </h1>
                                        <h1 class="h2 cursor-pointer" v-else-if="data_B.unique != null" @click="get_list( 'all', data_B.link )" > 
                                            {{ Numberformatter( data_B.unique, 'plain-number' ) }}
                                        </h1>
                                        <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium cursor-pointer" @click="get_list( 'all', data_B.link )" > Visitors </p>
                                    </div>
                                </div>

                                <div class="col p-3 text-right "  >
                                    <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                        <h1 class="h2" v-if="data_B.total == null || data_B.total == 0" > - </h1>
                                        <h1 class="h2" v-else-if="data_B.total != null"  > 
                                            {{ Numberformatter( data_B.total, 'plain-number' ) }}
                                        </h1>
                                        <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Visits </p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <!-- -->
                    
                    <div class="mt-4 mb-4 ml-3 mr-3" >
                        <line-chart v-if="CHART_SERIES.length > 0 && contentType == 'full'" :chart-data="CHART_SERIES" :chartCompare="CHART_SERIES_COMPARE" :labels="CHART_COLUMNS" :width="450" :height="440" symbol=" " :chartDataName="data_A.link" :chartDataCompareName="data_B.link" ></line-chart>
                    </div>
                    
                    <div class="col-4 mt-4 mb-4 ml-3 mr-3 d-none" >
                        <pie-chart v-if="SOURCE_CHART_COLUMNS.length > 0" :chart-data="SOURCE_CHART_SERIES" :labels="SOURCE_CHART_COLUMNS" :height="290" symbol=" "  :chartDataName="data_A.link" class="m-5" ></pie-chart>
                    </div>
                        
                </div>
                    
                <!-- PROGRESS BAR -->                            
                <div class="col-12 border-top-gray pt-5 pb-3" >

                    <spinner type="xsmall" v-if="SOURCE_CHART_DATA.length == 0" ></spinner>

                    <b-progress v-else-if="SOURCE_CHART_DATA.length > 0" :max="data_A.unique" class="mb-2 engagement-source-progress" height="30" >

                        <b-progress-bar v-for="(item, index) in SOURCE_CHART_DATA" :key="index+'sources'" :style="'background:#'+item.color" :label="item.name"  :value="item.engagements.length" :id="`tooltip--eng-sources-progress-`+index"  ></b-progress-bar>

                        <b-tooltip :target="`tooltip--eng-sources-progress-`+index" custom-class="tooltip-auto" placement="top" triggers="hover" v-for="(item, index) in SOURCE_CHART_DATA" :key="index+'-ttip'" >
                            {{ item.name }} - {{ item.engagements.length }} <span class="ml-2" > {{ ( ( item.engagements.length * 100 ) / data_A.unique ).toFixed(2) }}% </span>
                        </b-tooltip>

                    </b-progress>


                </div>
                <!-- PROGRESS BAR -->
                
                <div class="row mt-4 mr-0 ml-0" >
                    
                    <!-- ENGAGEMENT SOURCES -->
                    <div class="col-12 col-md-6 p-2 " >
                        <div class="p-2 border-gray border-radius" >
                            <div class="row no-gutters pt-2 pb-2 pl-4 pr-4 font-size-18 font-weight-bold text-uppercase Text-color--graylmedium border-bottom-gray " > Sources </div>
                            <div class="w-100 overflow-auto engagement-links" >
                                <spinner v-if="SOURCE_CHART_DATA.length == 0" ></spinner>

                                <div v-else-if="SOURCE_CHART_DATA.length > 0" class="row no-gutters pt-2 pb-2 pl-2 pr-3 font-size-14 border-top-gray border-top-f-none" v-for="(item, index) in SOURCE_CHART_DATA" :key="index+'-source-e'" >

                                    <div class="col-9 font-weight-bold"  >
                                        <span class="round-dot mr-2 d-inline-block" :style="'background:#'+item.color" ></span>
                                        <span @click="fModalOpen( item.engagements )" class="cursor-pointer" > {{ item.name }} </span> 
                                    </div> 
                                    <div class="col-3 font-weight-bold text-right"  > 
                                        {{ item.engagements.length }} visitors
                                        <span class="ml-3 font-weight-normal Text-color--graylmedium " > {{ ( ( item.engagements.length * 100 ) / data_A.unique ).toFixed(2) }}% </span> 
                                    </div> 

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ENGAGEMENT SOURCES -->
                    
                    <!-- ENGAGEMENT CLICKS -->
                    <div class="col-12 col-md-6 p-2" >
                        <div class="p-2 border-gray  border-radius" >
                            <div class="row no-gutters pt-2 pb-2 pl-4 pr-4 font-size-18 font-weight-bold text-uppercase Text-color--graylmedium border-bottom-gray" > Links </div>
                            <div class="w-100 overflow-auto engagement-links" >
                                <spinner v-if="MOST_CLICKED_LINKS.length == 0" ></spinner>

                                <div v-else-if="MOST_CLICKED_LINKS.length > 0" class="row no-gutters pt-2 pb-2 pl-2 pr-3 font-size-14 border-top-gray border-top-f-none" v-for="(item, index) in MOST_CLICKED_LINKS" :key="index+'-referal-e'" >

                                    <div class="col-9 font-weight-bold"  >
                                        <span @click="fModalOpen( item.engagements )" class="cursor-pointer" :id="`tooltip--eng-links-`+index" > {{ truncateString( item.name ) }} </span> 

                                        <b-tooltip :target="`tooltip--eng-links-`+index" custom-class="tooltip" placement="bottom" triggers="hover"  >
                                            {{ item.name }}
                                        </b-tooltip>

                                    </div> 
                                    <div class="col-3 font-weight-bold text-right"  > 
                                        {{ item.engagements.length }} visitors
                                        <span class="ml-3 font-weight-normal Text-color--graylmedium " > {{ ( ( item.engagements.length * 100 ) / data_A.unique ).toFixed(2) }}% </span> 
                                    </div> 

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ENGAGEMENT CLICKS -->
                </div>
                
            </div>
            
        </div>
        
        <div class="row no-gutters mt-5 " v-if="contentType == 'overview'" >
            
            <div class="col-12 p-3 border-gray border-radius" >
            
                <div class="col-12 pl-2 pr-4 pt-2 pb-2 "   >
                    <div class="row" >
                        <div class="col-8 col-md-6" >
                            <!-- <h1 class="h1 font-900 d-inline "> Today's engagement </h1> -->
                            <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Engagement  </span>

                            <h2 class="h2 graymedium-color font-300 d-inline-old ml-4 d-none" > 
                                {{ data_A.total }} visits
                                |
                                <span v-if=" data_A.unique != null" >  {{ data_A.unique }} visitors <a @click="get_list( 'all', data_A.link )" class="ml-1 font-size-11"  > <font-awesome-icon icon="arrow-circle-right" /> </a> </span>
                            </h2>

                        </div>
                        <div class="col-4 col-md-6 text-right" style="line-height: 34px;"  >

                            Refresh: 
                            <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>

                        </div>
                    </div>
                </div>

                <div class="col-12" >
                    <spinner v-if="!chartLoaded" ></spinner>

                    <div v-else-if="chartLoaded && CHART_SERIES.length == 0" class="p-5 text-center" > No data to show </div>

                    <div class="w-100 " v-else-if="chartLoaded && CHART_SERIES.length > 0" >

                        <!-- OVERVIEW -->
                        <div class="row border-top-gray" >

                            <!-- v2 -->
                            <div class="col-12 col-md-7 pr-3 pl-0 " >

                                <!-- -->
                                <div class="row no-gutters pr-0 ml-0 mb-2 border-bottom-gray " >

                                    <div class="col p-3 border-right-gray text-right" >
                                        <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                            <h1 class="h2" v-if="data_A.unique == null" > - </h1>
                                            <h1 class="h2 cursor-pointer" v-else-if="data_A.unique != null"  @click="get_list( 'all', data_A.link )"  > 
                                                {{ Numberformatter( data_A.unique, 'plain-number' ) }}
                                            </h1>
                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium cursor-pointer"  @click="get_list( 'all', data_A.link )"  > Visitors </p>
                                        </div>
                                    </div>

                                    <div class="col p-3 text-right " >
                                        <div class=" pt-2 pb-2 pl-4 pr-4 bg-white" >
                                            <h1 class="h2" v-if="data_A.total == null" > - </h1>
                                            <h1 class="h2" v-else-if="data_A.total != null" > 
                                                {{  Numberformatter( data_A.total, 'plain-number' ) }}
                                            </h1>
                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Visits </p>
                                        </div>
                                    </div>

                                </div>
                                <!-- -->

                                <line-chart v-if="CHART_SERIES.length > 0" :chart-data="CHART_SERIES" :chartCompare="CHART_SERIES_COMPARE" :labels="CHART_COLUMNS" :height="290" symbol=" "  :chartDataName="data_A.link" class="m-0 m-md-5" ></line-chart>
                                
                            </div>
                            
                            <div class="col-12 col-md-5 border-left-gray border-md-left-none mt-4 mt-md-0 pr-0 pl-0" >

                                <div class="engagement-sources overflow-auto" >
                                    <spinner v-if="!dataLoaded" ></spinner>
                                    <div v-else-if="dataLoaded && SOURCE_CHART_DATA.length == 0" class="col-12 mt-5 text-center " >
                                        No data
                                    </div>
                                    
                                    <div v-else-if="dataLoaded && SOURCE_CHART_DATA.length > 0" class="row no-gutters pt-2 pb-2 pl-2 pr-3 font-size-14 border-top-gray border-top-f-none" v-for="(item, index) in SOURCE_CHART_DATA" :key="index" >

                                        <div class="col-9 font-weight-bold"  >
                                            <span class="round-dot mr-2 d-inline-block" :style="'background:#'+item.color" ></span>
                                            <span @click="fModalOpen( item.engagements )" class="cursor-pointer" > {{ item.name }} </span> 
                                        </div> 
                                        <div class="col-3 font-weight-bold text-right"  > {{ item.engagements.length }} <span class="ml-2 font-weight-normal Text-color--graylmedium " > {{ ( ( item.engagements.length * 100 ) / data_A.unique ).toFixed(2) }}% </span> </div> 

                                    </div>
                                </div>

                            </div>
                            <!-- v2 -->

                            <div class="col-12 p-0" >

                                <div class="col-12 border-top-gray pl-0 pr-0 pt-4 pb-2" >

                                    <spinner type="xsmall" v-if="!dataLoaded" ></spinner>
                                    <div v-else-if="dataLoaded && SOURCE_CHART_DATA.length == 0" class="col-12 text-center " >
                                        No data
                                    </div>

                                    <b-progress v-else-if="dataLoaded && SOURCE_CHART_DATA.length > 0" :max="data_A.unique" class=" engagement-source-progress" height="30" >

                                        <b-progress-bar v-for="(item, index) in SOURCE_CHART_DATA" :key="index" :style="'background:#'+item.color" :label="item.name"  :value="item.engagements.length" :id="`tooltip--eng-sources-progress-`+index"  ></b-progress-bar>

                                        <b-tooltip :target="`tooltip--eng-sources-progress-`+index" placement="top" triggers="hover" v-for="(item, index) in SOURCE_CHART_DATA" :key="index+'-source'" >
                                            {{ item.name }} - {{ item.engagements.length }} <span class="ml-2" > {{ ( ( item.engagements.length * 100 ) / data_A.unique ).toFixed(2) }}% </span>
                                        </b-tooltip>

                                    </b-progress>


                                </div>
                            </div>

                        </div>
                        <!-- OVERVIEW -->

                    </div>

                </div>

            </div>
            
        </div>
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="engagement" ></modal>
        
    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import analyzeToday from '@/components/analyzeToday.vue'    
import lineChart from '@/components/charts/lineChart_full.js'   
import barChart from '@/components/charts/barChart_full.js'   
import chartBlock from '@/components/chartBlock.vue'    
import modal from '@/components/modal.vue'    
import pieChart from '@/components/charts/pieChart.js'    
    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "organizations",
    components:{
        lineChart,
        barChart,
        chartBlock,
        analyzeToday,
        modal,
        pieChart
    },
    props:{
        contentType: { type: [ String ], default: 'full' }, /* full -> full page; overview -> overview source */ 
        parentPeriod: { type: [ Array ], default: null }, 
        passedAPPKEY:{ type : [String, Boolean], default: false }
    },
    data () {
        return {
            loaded: false,
            filter: '',
            rows: [],
            
            dataLoaded: false,
            modalData: null,
            modalState: false,
            
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        console.log( Date.now() )
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'d').toDate();
                        let end = this.$moment( ).subtract(1,'d').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            
            data_A: {
                type: 'A',
                default: false,
                link: '',
                total: 0,
                unique: 0,
                data: []
            },
            data_B: {
                type: 'B',
                default: false,
                link: '',
                total: 0,
                unique: 0,
                data: []
            },
            default_links:{
                link_A: '',
                link_B: '',
            },
            chartLoaded: false,
            
            LIST_DATA:[],

            SOURCE_CHART_DATA: [],
            SOURCE_CHART_COLUMNS: [],
            SOURCE_CHART_SERIES: [],

            MOST_CLICKED_LINKS: [],
            
            CHART_COLUMNS: [],
            CHART_SERIES: [],
            CHART_SERIES_COMPARE: [],

            smallChartOptions:{
                maxTicksLimit: 1,
                yAxesgridLines: false
            },
            
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        this.loaded = true
        //this.getLink( 'A' )
        /*
        let ACCOUNT_SETTINGS = helper.getAccountSettings()
        if( ACCOUNT_SETTINGS && ACCOUNT_SETTINGS.engagement && ACCOUNT_SETTINGS.engagement.link_A  ){
            this.default_links.link_A = ACCOUNT_SETTINGS.engagement.link_A
            this.data_A.link = this.default_links.link_A
        }
        if( ACCOUNT_SETTINGS && ACCOUNT_SETTINGS.engagement && ACCOUNT_SETTINGS.engagement.link_B  ){
            this.default_links.link_B = ACCOUNT_SETTINGS.engagement.link_B
            this.data_B.link = this.default_links.link_B
        }
        
        
        */
        this.init_period()
        
    },
    computed: {
    },
    methods: {
        init_period(){
            let end = this.$moment(Date.now()).format('D MMM YYYY');
            //let start = this.$moment(Date.now()).subtract(30,'d').format('D MMM YYYY');
            let start = this.$moment(Date.now()).startOf('day').format('D MMM YYYY');

            if( this.parentPeriod != null ){
                start = this.parentPeriod[0]
                end = this.parentPeriod[1]
            }
            
            this.period = [ start, end ];
            
            //this.get_data()
            this.refreshData('data_A')
            
        },

        get_data(data){
            
            //from firebase
             //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            //console.log( this.period )
            
            let searchPhrase = data.link
            if( searchPhrase.includes( 'https://' ) ){
                searchPhrase = searchPhrase.replace('https://','')
            }
            
            data.data = []
                    
            if( data.type == 'A' ){
                this.CHART_COLUMNS = []
                this.CHART_SERIES = []
            }else{
                this.CHART_SERIES_COMPARE = []
            }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            //console.log( timezone + "| " + start + " - " + end )
            
            axios({ 
                method: 'POST', 
                url: process.env.ROOT_API+'/analyze/engagement', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                    "searchPhrase": searchPhrase
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){

                    //let sales = resp.data.body;
                    let clicks = resp.data.data;
                    let groupped_clicks = helper.groupSalesBy( clicks, start, end )
                    console.log( groupped_clicks )
                    
                    let format = 'YYYY-MM-DD HH:mm'
                    this.data_A.unique = 0
                    this.data_B.unique = 0
                    this.data_A.total = 0
                    this.data_B.total = 0
                    
                    this.LIST_DATA = []
                    this.LIST_DATA = clicks.filter((value, index, self) =>
                      index === self.findIndex((t) => (
                        t.leadID === value.leadID 
                      ))
                    )
                    
                    groupped_clicks.forEach((d)=>{
                        
                        //sort list by datetime
                        d.list.sort((a, b) => a.datetime - b.datetime);
                        let unique = d.list.filter((value, index, self) =>
                          index === self.findIndex((t) => (
                            t.leadID === value.leadID 
                          ))
                        )
                        //console.log( unique )
                        d.list = unique
                        d.uniqueCount = d.list.length
                        //keep only unique leadid
                        
                        
                        //let day = moment.tz( d.date, 'UTC' ).tz( timezone ).format('YYYY-MM-DD') 
                        //let daytime = moment.tz( d.date, 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm')
                        
                        let day = moment( d.date ).format('YYYY-MM-DD') 
                        let daytime = moment( d.date ).format('YYYY-MM-DD HH:mm') 
                        
                        if( 
                            day >= this.$moment(this.period[0]).format('YYYY-MM-DD') 
                           && day <= this.$moment(this.period[1]).format('YYYY-MM-DD HH:mm') 
                           && daytime <= moment.tz( new Date( moment.utc().format() ), 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm') 
                          ){
                            
                            data.data.push( d )
                            if( data.type == 'A' ){
                                //this.CHART_COLUMNS.push( moment.tz( d.day, 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm:ss') )
                                //this.CHART_COLUMNS.push( moment.tz( d.date, 'UTC' ).tz( timezone ).format( format ) )
                                this.CHART_COLUMNS.push( daytime )
                                this.CHART_SERIES.push( d.uniqueCount )
                                this.data_A.total += d.count
                                //this.data_A.total += d.uniqueCount
                                //this.data_A.unique += d.uniqueCount
                                this.data_A.unique = this.LIST_DATA.length
                                
                            }else{
                                this.CHART_SERIES_COMPARE.push( d.uniqueCount )
                                this.data_B.total += d.count
                                //this.data_B.total += d.uniqueCount
                                //this.data_B.unique += d.uniqueCount
                                this.data_B.unique = this.LIST_DATA.length
                            }
                            
                        }
                            
                    })
                    
                    //let unique = helper.uniqueItems( clicks, 'leadID' )
                    
                    return groupped_clicks
                    
                }else{
                    console.log(resp)
                }                
                
            })
            .then(function(sales){
                
                //group results by SOURCE
                let results = helper.groupResultsBy( 'source', this.LIST_DATA )
                results.sort((a, b) => b.engagements.length - a.engagements.length);



                //console.log(results)
                results.forEach((r, i)=>{
                    this.SOURCE_CHART_COLUMNS.push( r.name )
                    this.SOURCE_CHART_SERIES.push( r.engagements.length )
                    //r.color = Math.floor(Math.random()*16777215).toString(16);
                    r.color = this.getDarkColor(i)
                    if( r.tag == 'unattributed' ){ r.color = '666666' } 
                })
                this.SOURCE_CHART_DATA = results

                //group results by refferal link ( most clicked links )
                let results2 = helper.groupResultsBy( 'refferalURL', this.LIST_DATA )
                results2.sort((a, b) => b.engagements.length - a.engagements.length);
                this.MOST_CLICKED_LINKS = results2
                //console.log( this.MOST_CLICKED_LINKS )    
                
                this.chartLoaded = true
                this.dataLoaded = true
                this.loaded = true;
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        get_data_sql( data ){
            
            this.chartLoaded = false
            
            //data = EITHER data_A or data_B
            
            //TEST DUMMY
            //let searchPhrase = 'muscleintelligence.com'
            
            let searchPhrase = data.link
            if( searchPhrase.includes( 'https://' ) ){
                searchPhrase = searchPhrase.replace('https://','')
            }
            
            if( data.type == 'A' ){
                this.data_A.total = 0
                this.data_A.unique = 0
            }else if( data.type == 'B' ){
                this.data_B.total = 0
                this.data_B.unique = 0
            }
                        
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            //let start = moment.tz(this.period[0], timezone ).startOf('day').format('YYYY-MM-DD HH:mm:ss')
            //let end = moment.tz(this.period[1], timezone ).endOf('day').format('YYYY-MM-DD HH:mm:ss')
            let offset = moment.tz(this.period[0], timezone ).format('Z')
            //console.log(offset)
            //console.log( timezone + "| " + start + " - " + end )
            
            //console.log( "Request start date: "+ start + " ( "+ moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix() +" )" )
            //console.log( helper.getAccountSettings() )
            
            let signup = helper.getAccountSettings().datetime
            if( moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix() < signup ){
                //console.log( "Cannot request data for date prior to sign up" );
                start = moment.unix( signup ).tz("UTC").format( 'YYYY-MM-DD HH:mm:ss' )
            }
            
            axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/api/stats.php?s='+searchPhrase,
                url: 'https://sql.theatlass.com/api-v2/getStats.php?s='+searchPhrase,
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment.utc(this.period[0]).format('YYYY-MM-DD'),
                    "startDate":  start,
                    //"endDate":  moment.utc(this.period[1]).add(1, 'day').format('YYYY-MM-DD'),
                    "endDate":  end,
                    "tz_to": offset,
                    "searchPhrase": searchPhrase,
                    //"filters":  { key: "email", operator: "!=", value: "" }
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let interval = resp.data.data.interval
                    let response_data = resp.data.data.results
                    let count_unique = null
                    if( resp.data.data.total && resp.data.data.total.length > 0 ){
                        count_unique = resp.data.data.total[0].uniqueCount
                    }
                         
                    //console.log(data)
                    //PROCESS DATA
                    //data.data = response_data
                    data.data = []
                    
                    if( data.type == 'A' ){
                        this.CHART_COLUMNS = []
                        this.CHART_SERIES = []
                    }else{
                        this.CHART_SERIES_COMPARE = []
                    }
                    
                    let format = 'YYYY-MM-DD'
                    if( interval == 'hours' ){
                        format = 'YYYY-MM-DD HH:mm:ss'
                    }
                    
                    response_data.forEach((d)=>{
                                                
                        if( 
                            moment.tz( d.day, 'UTC' ).tz( timezone ).format('YYYY-MM-DD') >= this.$moment(this.period[0]).format('YYYY-MM-DD') 
                           && moment.tz( d.day, 'UTC' ).tz( timezone ).format('YYYY-MM-DD') <= this.$moment(this.period[1]).format('YYYY-MM-DD') 
                           && moment.tz( d.day, 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm:ss') <= moment.tz( new Date( moment.utc().format() ), 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm:ss') 
                          ){
                            
                            data.data.push( d )
                            if( data.type == 'A' ){
                                //this.CHART_COLUMNS.push( moment.tz( d.day, 'UTC' ).tz( timezone ).format('YYYY-MM-DD HH:mm:ss') )
                                this.CHART_COLUMNS.push( moment.tz( d.day, 'UTC' ).tz( timezone ).format( format ) )
                                this.CHART_SERIES.push( d.uniqueCount )
                                this.data_A.total += d.count
                                //this.data_A.total += d.uniqueCount
                                //this.data_A.unique += d.uniqueCount
                                this.data_A.unique = count_unique
                                
                            }else{
                                this.CHART_SERIES_COMPARE.push( d.uniqueCount )
                                this.data_B.total += d.count
                                //this.data_B.total += d.uniqueCount
                                //this.data_B.unique += d.uniqueCount
                                this.data_B.unique = count_unique
                            }
                            
                        }
                            
                            
                    })
                    
                    //if( this.contentType == 'overview' ){
                        
                        this.SOURCE_CHART_DATA = []
                        
                        //this.get_data_list( moment().format('YYYY-MM-DD'), searchPhrase )
                        this.get_data_list( 'all', searchPhrase )
                        .then((data)=>{
                            
                            //group results by SOURCE
                            let results = helper.groupResultsBy( 'source', this.LIST_DATA )
                            results.sort((a, b) => b.engagements.length - a.engagements.length);
                            
                            
                            
                            //console.log(results)
                            results.forEach((r, i)=>{
                                this.SOURCE_CHART_COLUMNS.push( r.name )
                                this.SOURCE_CHART_SERIES.push( r.engagements.length )
                                //r.color = Math.floor(Math.random()*16777215).toString(16);
                                r.color = this.getDarkColor(i)
                                if( r.tag == 'unattributed' ){ r.color = '666666' } 
                            })
                            this.SOURCE_CHART_DATA = results
                            
                            //group results by refferal link ( most clicked links )
                            let results2 = helper.groupResultsBy( 'refferalURL', this.LIST_DATA )
                            results2.sort((a, b) => b.engagements.length - a.engagements.length);
                            this.MOST_CLICKED_LINKS = results2
                            //console.log( this.MOST_CLICKED_LINKS )     
                        })  
                        
                    //} // end if( this.contentType == 'overview' )

                    this.chartLoaded = true
                    this.dataLoaded = true

                }else{
                    console.log("")
                }                
            })
            .then(function(){
                
                //this.rows.push( data )
                this.loaded = true;
                
            }.bind(this))
            
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },
        
        get_list( day, searchPhrase ){
          
            this.$toast.info({
                title:'Info',
                message: 'Fetching data...'
            })
            
            /*
            this.get_data_list( day, searchPhrase )
            .then((data)=>{
                //console.log(data)
                this.fModalOpen( this.LIST_DATA )
            })
            */
            
            //console.log(day)
            //console.log(this.data_A)
            if( day == 'all' ){
               this.fModalOpen( this.LIST_DATA )
            }else{
                this.data_A.data.forEach((item)=>{
                    //console.log( item.date +" - "+ day )
                    if( item.date == day ){
                        this.fModalOpen( item.list )
                    }
                })
            }
                
            
        },
        
        get_data_list( day, searchPhrase ){
            
            //this.chartLoaded = false
            
            //data = EITHER data_A or data_B
            
            //TEST DUMMY
            //let searchPhrase = 'muscleintelligence.com'
            
            //let searchPhrase = data.link
            if( searchPhrase.includes( 'https://' ) ){
                searchPhrase = searchPhrase.replace('https://','')
            }
            if( searchPhrase.includes( 'http://' ) ){
                searchPhrase = searchPhrase.replace('http://','')
            }

            let timezone = helper.getAccountTimezone()            
            
            let start = moment.tz(day, timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(day, timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            if( day.length == 19 ){
                start = moment.tz(day, timezone ).startOf('hour').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                end = moment.tz(day, timezone ).endOf('hour').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            }
            
            if( day == 'all' ){
                start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            }
            
            //console.log( timezone + "| " + start + " - " + end )
            
            
            return axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment.utc(day).format('YYYY-MM-DD 00:00:00'),
                    //"endDate":  moment.utc(day).format('YYYY-MM-DD 23:59:59'),
                    "startDate":  start,
                    "endDate":  end,
                    "searchPhrase": searchPhrase,
                    //"filters":  { key: "email", operator: "!=", value: "" }
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let response_data = resp.data.data.results
                                      
                    //console.log(response_data)
                    //PROCESS DATA
                    let data = []
                    response_data.forEach((lead)=>{
                        //lead.datetime = moment.utc(lead.date).unix()
                        
                        if( lead.email == null ){
                            /*
                            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
                            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/leads').doc( lead.leadID ).get()
                                    .then((doc) => {
                                        
                                        let item = {};                
                                        item = doc.data(); // will have 'todo.title'
                                        item.id = doc.id;

                                        //console.log(item)

                                        if( item.email ){
                                            lead.email = item.email
                                        }else{
                                            lead.email = "Unknown email ( visitor ) "
                                        }
                                        data.push( lead )

                                    })
                            */
                            
                            lead.email = "Visitor"
                            data.push( lead )
                            
                        }else{
                            data.push( lead )
                        }
                        
                    })
                    
                    this.LIST_DATA = data
                    
                }else{
                    console.log("")
                }                
            })
            .then(function(){

                return this.LIST_DATA
                
            }.bind(this))
            
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },
        
        refreshData( target ){
            
            this.SOURCE_CHART_DATA = []
            //console.log(target)
            this.get_data( this.data_A )
            
            if( target == 'data_A' && this.data_A.link != '' ){
                //this.get_data( this.data_A )
                
            }else{
                //this.loaded = true;
                //this.chartLoaded = true
            }
            
            if( target == 'data_B' && this.data_B.link != '' ){
                this.get_data( this.data_B )
            }        
            
        },
        
        getDarkColor(val) {
            var lum = -0.04;
            var hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var rgb = "",
                c, i;
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00" + c).substr(c.length);
            }
            return rgb;
        },
        
        refresh_chart( $event ){
            
            //console.log($event)
            this.rows = []
            this.LIST_DATA = []
            this.SOURCE_CHART_DATA = []
            this.MOST_CLICKED_LINKS = []
            
            this.SOURCE_CHART_COLUMNS = []
            this.SOURCE_CHART_SERIES = []
                        
            if( this.period[0] == null || this.period[1] == null ){
                this.init_period()
            }else{
                
                this.refreshData( 'data_A' )
                if( this.data_A.link != '' ){
                    
                }
                if( this.data_B.link != '' ){
                    this.refreshData( 'data_B' )
                }

            }
            
        },

        groupBySource( data ){
            
            
            
        },   
       
        Numberformatter(value, type, html ) {
            
            return helper.Numberformatter(value, type, html );
            
        },
        
        //MODAL AND NAVIGATION
        openCampaign(params){
            //console.log(params)
            if( params.row.open != false ){
                this.fModalOpen( 'source', params.row );
            }
                
        },
        User(params){
            //console.log(params)
            this.fModalOpen( 'lead', params.row );
        },
        fModalOpen( data ){
            this.modalData = data
            this.modalState = true
        },
        
        //filter functions
        showEmptySources( source ){
            if( !this.showEmpty ){
                if( source.orders.length > 0 ){ return true }
                else{
                    return false
                }
            }else{
                return true
            }
        },
        
        testChange(){
            console.log(this.selected_sourcesOrigin)
        },
      
        resourcesLink( query ){
            //console.log( process.env.ROOT_DOMAIN_RESOURCES )
            //https://theatlass.com/help/docs/learn-about-attribution-modes/
            return process.env.ROOT_DOMAIN_RESOURCES + '/docs/'+query
        },
        
        saveLink( type ){
            
            let link;
            if( type == 'A' ){
                link = this.data_A.link
                this.default_links.link_A = link
            }else if( type == 'B' ){
                link = this.data_B.link
                this.default_links.link_B = link
            }
            
            //console.log( "save default link "+ type + " : "+  link )
            
            let APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let ref = this.$firebase.firestore().collection('organizations').doc( APPKEY )

            let settings = { engagement: {} }
            settings.engagement.link_A = link
            
            return ref.set( { settings: settings }, { merge: true }  )
            .then((result)=>{
                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved'
                })
                
                //store.dispatch("AUTH_CHECK");
                
            })
            
        },
        
        getLink( type ){
            
            //GET SETTINGS FROM DATABASE
            //let APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let APPKEY = ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) )
            let ref = this.$firebase.firestore().collection('organizations').doc( APPKEY )

            return ref.get()
            .then((snapshot) => {
                if( !snapshot.empty ){
                    //console.log(snapshot.data())
                    let org = snapshot.data()
                    org.ID = snapshot.id
                    if( type == 'A' && org.settings && org.settings.engagement && org.settings.engagement.link_A ){
                        this.default_links.link_A = org.settings.engagement.link_A
                        this.data_A.link = this.default_links.link_A
                    }else if( type == 'B' && org.settings && org.settings.engagement && org.settings.engagement.link_B ){
                        this.default_links.link_B = org.settings.engagement.link_B
                        this.data_B.link = this.default_links.link_B
                    }
                        
                    
                }
                //this.getOrg()
            })
            .then((result)=>{
                this.init_period()
            })
            
            
            
        },
        
        truncateString(value){
            if( value.length > 66 ){
                return value.substring(0,66) + "..."
            }else{
                return value
            }
                
        },
        
    },
    watch:{
        parentPeriod(){
            this.init_period()
        }
    },
    computed:{

        
    },
}
</script>


<style lang="scss" >
    
     @import '@/assets/css/variables.scss';
    
    .w-45{
        width: 48%;
    }
    
    .w-45 > .input-group-text,
    .w-4 > .input-group-text
    {
        width: 100%;
    }
    
    .w-4{
        width: 4%;
    }

    .col-55{
        width: 45.8%;
    }
    
</style>


// WEBPACK FOOTER //
// src/templates/analyze/Engagement.vue